<template>
  <div class="horse-purchase-home">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "HorsePurchaseHome",
  metaInfo() {
    return {
      title: this.$t("HORSE_PURCHASE.horse_purchase"),
    };
  },
  transition: "fadeInUp",
};
</script>

<style scoped>
.horse-purchase-home {
  width: 100%;
  height: 100%;
}
</style>